// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CountUpController from "./count_up_controller"
application.register("count-up", CountUpController)

import CopyToClipboardController from "./copy_to_clipboard_controller"
application.register("copy-to-clipboard", CopyToClipboardController)

import FlashModalController from "./flash_modal_controller"
application.register("flash-modal", FlashModalController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LazyImageController from "./lazy_image_controller"
application.register("lazy-image", LazyImageController)

import LenisController from "./lenis_controller"
application.register("lenis", LenisController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import QuillController from "./quill_controller"
application.register("quill", QuillController)

import SplideController from "./splide_controller"
application.register("splide", SplideController)

import TMapController from "./t_map_controller"
application.register("t-map", TMapController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)
